module.exports = __webpack_public_path__ + "public/SideMenuIcons/manageFare.svg?09b92f16";